<template>
  <div class="products">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">{{ util.language('信息', 'Product') }}</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('姓名', 'Name')">
        <el-input style="width: 120px;" :placeholder="util.language('精准匹配', '')" v-model="searchParam.name" clearable />
      </el-form-item>
      <el-form-item :label="util.language('身份证号', 'IdCard')">
        <el-input style="width: 120px;" :placeholder="util.language('精准匹配', '')" v-model="searchParam.idCard" clearable />
      </el-form-item>
      <el-form-item :label="util.language('证书编号', 'Certificate Number')">
        <el-input style="width: 120px;" :placeholder="util.language('精准匹配', '')" v-model="searchParam.certificateNumber" clearable />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('搜索', 'Search') }}</el-button>
          <el-tooltip :content="util.language('按当前筛选条件导出', 'Export by current search condition')" placement="top">
            <el-button type="warning" @click="exportExcel()" :loading="loading.exportExcel">{{ util.language('导出', 'Export') }}</el-button>
          </el-tooltip>
          <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="info" @click="show.importShow = true">{{ util.language('导入', 'Import') }}</el-button>
          <el-button type="primary" @click="add()">{{ util.language('新增', 'New') }}</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">{{ util.language('详情', 'Detail') }}</el-button>
          <el-button type="danger" :disabled="show.selected.length != 1" @click="del()">{{ util.language('删除', 'Delete') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.productList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="70" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="姓名" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="seriesName" label="系列名称" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="sex" label="性别" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="majorName" label="专业名称" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="nativePlace" label="籍贯" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="qualificationName" label="资格名称" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="birthDate" label="出生日期" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="approveDate" label="批准日期" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="issueUnit" label="发证单位" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="issueDate" label="发证日期" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="netHost" label="网址" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="idCard" label="身份证号" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="remark" label="备注" align="center" width="100" show-overflow-tooltip />
      <el-table-column prop="certificateNumber" label="证书编号" align="center" width="100" show-overflow-tooltip />
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.productTotal" @change="commitFindList()" />
  </div>

  <el-dialog v-model="show.importShow" :title="util.language('确认导入', 'Confirm import')" width="600">
    <el-form>
      <el-form-item>
        <el-text>{{ util.language('请先', 'Please ') }}</el-text>
        <el-link type="primary" @click="importExcelTemplate()">{{ util.language('下载导入模版', 'Download import template ') }}</el-link>
        <el-text>{{ util.language('，填写模板内容再导入。', 'first, then fill in the template content and import.') }}</el-text>
        <br>
        <el-text type="danger">{{ util.language('模板格式不对应可能造成导入数据混乱，请注意。', 'The template format may cause the imported data to be disordered.') }}</el-text>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-upload :loading="loading.importExcel" :action="api.baseURL() + '/backend/product/importExcel'" :headers="api.tokenHeader()" :on-progress="importExcelProgress" :on-success="importExcelSuccess" :on-error="importExcelError"
          :show-file-list="false">
          <el-button type="primary">{{ util.language('导入', 'Import') }}</el-button>
        </el-upload>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const loading = reactive({
  find: false,
  exportExcel: false,
  importExcel: false,
})
const data = reactive({
  productList: [],
  productTotal: 0,
})

const show = reactive({
  importShow: false,
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 50
  searchParam.name = ''
  searchParam.idCard = ''
  searchParam.certificateNumber = ''
}
resetSearchParam()

const buildSearchParam = () => {
  const params = JSON.parse(JSON.stringify(searchParam))
  if (params.state) {
    if (params.state == 1) {
      params.hasUsed = true
    }
    if (params.state == 2) {
      params.hasUsed = false
    }
    if (params.state == 3) {
      params.enable = true
    }
    if (params.state == 4) {
      params.enable = false
    }
    params.state = null
  }
  return params
}

const commitFindList = () => {
  loading.find = true
  const params = buildSearchParam()
  api.get('/backend/product/getProductPage', { params }).then(res => {
    data.productList = res.list
    data.productTotal = res.total
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'product', null)
  router.push('/product')
}

const update = (row) => {
  const product = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'product', product)
  router.push('/product')
}

const del = (row) => {
  const product = row ? row : tabRef.value.getSelectionRows()[0]
  ElMessageBox.confirm(util.language('确定删除吗？', 'Are you sure to delete it?'), util.language('提示', 'Prompt'), {
    confirmButtonText: util.language('确定', 'Confirm'),
    cancelButtonText: util.language('取消', 'Cancel'),
    type: 'warning',
  }).then(() => {
    api.post('/backend/product/delProduct', { id: product.id }).then(() => {
      ElMessage.success(util.language('删除成功', 'Delete success'))
      commitFindList()
    })
  })
}

/** 下载导入模板 */
const importExcelTemplate = () => {
  apiNative.get('/backend/product/importExcelTemplate', {
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    ElMessage.info(util.language('开始下载', 'downloading'))
    util.downloadFile(res.data, "导入模板.xlsx")
  }).catch((e) => {
    console.error(e)
    ElMessage.error(util.language('下载失败，请联系系统管理员', 'Download failed, please contact the system administrator'))
  })
}

/** 导入中 */
const importExcelProgress = () => {
  loading.importExcel = true
  ElMessage.success(util.language('正在导入！如果数据量大可能时间较长，请耐心等待。', 'Importing! If the data is large, it may take a long time. Please be patient.'))
}

/** 导入完成 */
const importExcelSuccess = (res) => {
  loading.importExcel = false
  if (res.code != 'S000001') {
    ElMessage.error(util.language('导入失败，请联系系统管理员', 'Import failed, please contact the system administrator'))
    return
  }
  show.importShow = false
  let cnMessage = '<p>本次导入，共计识别到：' + res.data.all + '条数据</p>'
  cnMessage += '<p>成功：<span style="color:green"> ' + res.data.success + ' </span>条数据</p>'
  cnMessage += '<p>失败：<span style="color:red"> ' + res.data.error + ' </span>条数据</p>'
  if (res.data.error > 0) {
    for (const failIndex in res.data.failRowList) {
      cnMessage += '<p>第 ' + res.data.failRowList[failIndex].row + ' 行：' + res.data.failRowList[failIndex].reason + '</p>'
    }
  }
  let enMessage = '<p>Total number of data recognized this time: ' + res.data.all + ' </p>'
  enMessage += '<p>Successful：<span style="color:green"> ' + res.data.success + ' </span>data</p>'
  enMessage += '<p>Failed：<span style="color:red"> ' + res.data.error + ' </span>data</p>'
  if (res.data.error > 0) {
    for (const failIndex in res.data.failRowList) {
      enMessage += '<p>Row ' + res.data.failRowList[failIndex].row + ': ' + res.data.failRowList[failIndex].reason + '</p>'
    }
  }
  let message = util.language(cnMessage, enMessage)
  ElMessageBox.alert('', {
    title: util.language('导入完成', 'Import completed'),
    message: message,
    autofocus: false,
    dangerouslyUseHTMLString: true,
    confirmButtonText: util.language('确定', 'Confirm'),
  })
  res.data
}

/** 导入失败 */
const importExcelError = () => {
  loading.importExcel = false
  ElMessage.error(util.language('导入失败，请联系系统管理员', 'Import failed, please contact the system administrator'))
}

/** 导出表格 */
const exportExcel = () => {
  loading.exportExcel = true
  const params = buildSearchParam()
  apiNative.get('/backend/product/exportExcel', { params, responseType: 'blob' }).then(res => {
    const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
    ElMessage.info(util.language('导出完成，开始下载', 'Export completed, downloading'))
    util.downloadFile(res.data, fileName)
  }).catch(() => {
    ElMessage.error(util.language('导出失败，请联系系统管理员', 'Export failed, please contact the system administrator'))
  }).finally(() => {
    loading.exportExcel = false
  })
}
</script>

<style lang="less"></style>